// @ts-ignore
import Env from '../../../modules/Environment';
import { updateConfig } from '../../../../react/features/base/config/actions';
import { isTestModeEnabled } from '../../../../react/features/base/testing/functions';
/**
 * Configures the initial A/V devices before the conference has started.
 *
 * @returns {Function}
 */
export function configureInitialDevicesByWildix() {
    return (dispatch, getState) => new Promise(resolve => {
        if (!Env.isWizyconf()) {
            const state = getState();
            // @ts-ignore
            const { startWithAudioMutedWildix = config.startWithAudioMuted, 
            // @ts-ignore
            startWithVideoMutedWildix = config.startWithVideoMuted } = state['wildix/customStorageSettings'];
            const settings = {
                // @ts-ignore
                startWithAudioMuted: isTestModeEnabled(state) ? config.startWithAudioMuted : startWithAudioMutedWildix,
                // @ts-ignore
                startWithVideoMuted: isTestModeEnabled(state) ? config.startWithVideoMuted : startWithVideoMutedWildix
            };
            // @ts-ignore
            const { startWithScreenSharing, startFromSipCall, startWithAudioMuted } = config;
            // make sure that audio is ON and video is OFF in case of screen sharing or joining from SIP call
            if (startWithScreenSharing || startFromSipCall) {
                settings.startWithAudioMuted = false;
                settings.startWithVideoMuted = true;
            }
            if (startWithAudioMuted) {
                settings.startWithAudioMuted = true;
            }
            if (settings !== null && typeof settings === 'object') {
                dispatch(updateConfig({
                    ...settings
                }));
                Object.keys(settings).forEach(item => {
                    // @ts-ignore
                    if (config.hasOwnProperty(item)) {
                        // @ts-ignore
                        config[item] = settings[item];
                    }
                });
                resolve(settings);
            }
        }
        else {
            resolve({});
        }
    });
}
